export default __webpack_public_path__ + "static/media/girl1.6c356d53.jpg";